/**
 * Menu de l'en-tête et tiroir panier ouvert (15/10/2026, Davy : « si le tiroir est ouvert, aucun lien
 * du sous-menu ne fonctionne »).
 *
 * Sur ordinateur, le tiroir panier s'ouvre en colonne et la page rétrécit à côté (960 px sur un
 * écran de 1440) : le menu n'a plus la place, « Plantes & mélanges » et « Avis clients » passent dans
 * « Plus », dont le panneau n'affiche pas nos tuiles et dont les liens ne répondent pas.
 *
 * 1. Quand la souris arrive sur le menu alors que le tiroir est ouvert, on ferme le tiroir.
 * 2. Défaut d'Horizon : une fois le tiroir fermé (par nous, la croix ou Échap), la page reprend sa
 *    largeur mais le menu reste replié dans « Plus » (overflow-list n'observe que sa propre taille).
 *    On le force à se recalculer : il réagit à l'ajout d'un enfant (MutationObserver).
 *
 * Ne touche ni au tiroir ni au menu d'Horizon : on écoute le pointeur et la fermeture du tiroir.
 */
const recalculerMenu = () => {
  for (const liste of document.querySelectorAll('header overflow-list')) {
    const temoin = document.createElement('span');
    temoin.hidden = true;
    liste.appendChild(temoin);
    setTimeout(() => temoin.remove(), 50);
  }
};

document.addEventListener(
  'pointerover',
  (event) => {
    if (event.pointerType === 'touch') return;
    const cible = event.target instanceof Element ? event.target : null;
    if (!cible?.closest('header header-menu, header .menu-list')) return;
    const tiroir = /** @type {any} */ (document.getElementById('cart-drawer'));
    if (!tiroir?.querySelector('dialog')?.open) return;
    tiroir.close?.();
  },
  { passive: true }
);

// L'événement « close » d'un <dialog> ne remonte pas : on l'écoute en phase de capture.
document.addEventListener(
  'close',
  (event) => {
    if (!(event.target instanceof HTMLDialogElement) || !event.target.closest('#cart-drawer')) return;
    // Après la transition de la marge de la page (largeur rendue progressivement)
    recalculerMenu();
    setTimeout(recalculerMenu, 450);
  },
  true
);
